import React from 'react';
import { ManagedPopup } from 'js/components/common/Popup';
import { WebContentInner } from 'js/components/system/WebContent';
import { useCombinedOnClose } from 'js/components/common/PopupManager';
import { getAcceptDeclineButtons } from 'js/components/common/popups/ConfirmationPopup';

import * as Types from './types';
import * as hooks from './hooks';

import style from './SimpleDialogInfoPopup.scss';

export const SimpleDialogInfoPopup: React.FC<Types.ISimpleDialogInfoPopupParams> = ({
    id,
    message,
    onAccept,
    onDecline,
    actionId,
    acceptBtnText,
    declineBtnText
}) => {
    const handleSubmitDialog = hooks.useHandleSubmitDialog();
    const buttons = getAcceptDeclineButtons({
        onAcceptClick: useCombinedOnClose(() => handleSubmitDialog({ actionId, submitActionType: 'yes', afterSubmitAction: onAccept }), id),
        onDeclineClick: useCombinedOnClose(() => handleSubmitDialog({ actionId, submitActionType: 'no', afterSubmitAction: onDecline }), id),
        acceptBtnText,
        declineBtnText
    });

    return (
        <ManagedPopup
            id={id}
            isModal={true}
            buttons={buttons}
        >
            <WebContentInner className={style.description} content={message} />
        </ManagedPopup>
    );
};
